import React from 'react';
import { useLocation } from 'react-router-dom';

import { scrollToTop } from '@app/utils/scrollToTop';

const ScrollToTop: React.FC = () => {
	const location = useLocation();

	React.useEffect(() => {
		scrollToTop();
	}, [location]);

	return null;
};

export default ScrollToTop;
